export default {"src":"/forms/_next/static/media/jabra-logo.ef675cc8.svg","height":161,"width":473,"blurWidth":0,"blurHeight":0};